// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".FocusedNav-cls1___e61e85fc0339e45ecba{/*!*/}.FocusedNav-cls2__f54d19403f60125f5df3{flex:1 1 auto}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "FocusedNav-cls1___e61e85fc0339e45ecba",
	"cls2": "FocusedNav-cls2__f54d19403f60125f5df3 FocusedNav-cls1___e61e85fc0339e45ecba"
};
export default ___CSS_LOADER_EXPORT___;
